<template>
  <div ref="particle" class="particle">
    <img src="/static/images/electron.png" srcset="/static/images/electron@2x.png 2x"/>
  </div>
</template>

<script>
  import Updater from '@/Updater';
  import Rnd from '@/Rnd';

  export default {
    name: "particle",
    props: [],
    mounted() {

      // console.log(this.$refs.particle.parentNode, window.innerWidth);
      // this.$refs.particle.style.top = window.innerHeight;

      Updater.instance.add(this);

      this.component = this.$refs.particle;

      this.init();

    },
    methods: {

      init() {
        const x = this.$props.x || 0;
        const y = this.$props.y || 0;
        const width = this.$props.width || window.innerWidth;
        const height = this.$props.height || window.innerHeight;
        this.x = Rnd.integer(0, width);
        this.y = Rnd.integer(0, height);

        this.scale = Rnd.float(0.2, 0.8);
        this.component.style.transform = `scale(${this.scale})`;

        this.da = Rnd.float(0.001, 0.02);

        this.state = 0;

        this.a = Rnd.float(0, 2 * Math.PI);
        this.amod = Rnd.float(0.008, 0.02) * Rnd.sign();

        this.speed = Rnd.float(0.3, 1.7);
        this.speedMod = Rnd.float(0.008, 0.001);

        this.alpha = 0;
      },

      update(dt) {
        const t = Date.now();
        switch (this.state) {
          case 0:
            this.alpha += this.da;

            if (this.alpha >= 1) {
              this.state = 1;
              this.alpha = 1;
              this.et = t + Rnd.integer(500, 2000);
            }
            break;

          case 1:
            if (t > this.et) {
              this.state = 2;
            }
            break;

          case 2:
            this.alpha -= this.da;
            if (this.alpha <= 0) {
              this.init();
            }
            break;
        }
        if (this.state > -1) {
          this.x += Math.cos(this.a) * this.speed;
          this.y += Math.sin(this.a) * this.speed;
          this.a += this.amod;
          this.speed += this.speedMod;

        }
        this.component.style.left = this.x + 'px';
        this.component.style.top = this.y + 'px';
        this.component.style.opacity = this.alpha;

      }
    }
  }
</script>

<style scoped>
  .particle {
    position: absolute;
    top: 10px;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Particle.vue